// ======================================================================
// File Name       : ContentSingleQuestion
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, Button, Table } from 'react-bootstrap';
import SelectBox from '../../components/SelectBox';
import FileUpload from '../../components/FileUpload';
import FormControlValidate from '../FormControlValidate';
import ContentSingleQuestionAdvanceSetting from '../content/ContentSingleQuestionAdvanceSetting';
import ContentSingleQuestionAnswerList from '../content/ContentSingleQuestionAnswerList';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { VALIDATE_TYPE } from '../../constants/index';
import { ANSWER_FORMULA } from '../../constants/ContentConstant';

class ContentSingleQuestion extends React.Component {
  constructor() {
    super();
    this.validation = this.validation.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  onChange(event, data) {
    if (data === undefined) {
      const { name, value } = event.target;
      this.props.handleChange(name, value);
    } else {
      this.props.handleChange(event, data);
    }
  }

  render() {
    const {
      questionContent,
      questionUseForm,
      questionZipFileName,
      answerFormula,
      optionMarkKind,
      optionRandomUse,
      inputLimitType,
      inputLimit,
      answerInfo,
      buttonText,
      questionViewDirection,
      absolutePoint,
      limitTime,
      sankakuUseDistinct,
      explanationUse,
      explanationHtmlUse,
      explanationContent,
      explanationZipFileName,
      hintUse,
      hintHtmlUse,
      hintContent,
      hintZipFileName,
      handleQuestionHtmlFileChange,
      handleExplanationHtmlFileChange,
      handleHintHtmlFileChange,
      handleChange,
      handleCheckboxChange,
      openOrCloseAdvanceSetting,
      isClosedAdvanceSetting,
      showAddAnswerDlg,
      removeAnswer,
      questionRegister,
      questionKind,
    } = this.props;
    this.refsToValidate = [];
    const correctAnswerNumberList = [];
    const correctAnswerList = [];
    if (answerInfo && answerInfo.length > 0) {
      for (let i = 0; i < answerInfo.length; i++) {
        if (answerInfo[i].correctAnswerNumber) {
          correctAnswerNumberList.push(answerInfo[i].correctAnswerNumber);
        }
        // get correct answer list
        if (answerInfo[i].isCorrectAnswer) {
          correctAnswerList.push(answerInfo[i].answerChoice);
        }
      }
    }
    if (!(parseInt(questionKind, 10) === 0)) {
      return null;
    }
    const isQuestionUseForm = questionUseForm === '1';

    const formulaSelectiveType = [
      ANSWER_FORMULA.SELECTIVE_SINGLE_ANSWER,
      ANSWER_FORMULA.SELECTIVE_MULTIPLE_ANSWER,
      ANSWER_FORMULA.SELECTIVE_SORT_ANSWER,
    ];
    const isFormulaSelectiveType = formulaSelectiveType.indexOf(answerFormula) > -1;
    return (
      <div className="col-sm-12">
        <Form.Group className="form-info" style={{ display: 'none' }} />
        <Form.Group className="form-info">
          <Col as={Form.Label} sm={4}>
            問題内容<span className="required">&nbsp;(※)</span>
          </Col>
          <Col sm={4} className="padding-top-10">
            <Form.Check
              type='radio'
              name="questionUseForm"
              id="questionUseForm-0"
              className="padding-top-clear"
              inline
              value={0}
              checked={questionUseForm === '0'}
              onChange={this.onChange}
              label='HTMLを使用しない'></Form.Check>
          </Col>
          <Col sm={4} className="form-label">
            <Form.Check
              type='radio'
              name="questionUseForm"
              id="questionUseForm-1"
              className="padding-top-clear"
              inline
              value={1}
              checked={questionUseForm === '1'}
              onChange={this.onChange}
              label='HTMLを使用する'></Form.Check>
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          {!isQuestionUseForm &&
            <Col
              sm={{
                span: 7,
                offset: 4
              }}
              className="margin-bottom-10">
              <FormControlValidate
                as="textarea"
                className="textArea"
                rows={7}
                name="questionContent"
                onChange={this.onChange}
                value={questionContent}
                maxLength="30000"
                required
                label="問題内容"
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
              />
            </Col>}
          {isQuestionUseForm &&
            <Col
              sm={{
                span: 7,
                offset: 4
              }}
              className="margin-top-10">
              <FileUpload
                labelName="ファイル選択"
                inputId={'questionHtmlFileUploadBtn'}
                onChange={handleQuestionHtmlFileChange}
                fileName={questionZipFileName}
                accept=".zip"
              />
            </Col>}
          {isQuestionUseForm &&
            <Col
              sm={{
                span: 7,
                offset: 4
              }}
              as={Form.Label}>
              <FormControlValidate
                label="問題内容"
                validateType={VALIDATE_TYPE.LABEL}
                value={questionZipFileName && `ファイル名：${questionZipFileName}`}
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                required
              />
            </Col>}
        </Form.Group>
        {!isQuestionUseForm &&
        <div>
          <Form.Group >
            <Col as={Form.Label} sm={4} className="margin-top-15">
            解答方式
            </Col>
            <Col sm={7} className="margin-top-15">
              <SelectBox
                data={SELECT_BOX_DATA.ANSWER_FORMULA}
                name="answerFormula"
                value={answerFormula}
                onChange={this.onChange}
                required
                label={'解答方式'}
              />
            </Col>
          </Form.Group>
          { isFormulaSelectiveType
          ? <div>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                  選択肢記号種別
              </Col>
              <Col sm={7}>
                <SelectBox
                  data={SELECT_BOX_DATA.OPTION_MARK_TYPE}
                  name="optionMarkKind"
                  value={optionMarkKind}
                  onChange={this.onChange}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4} className="padding-left-15">
                  選択肢をランダムに表示する
              </Col>
              <Col sm={7} className="padding-top-10">
                <Form.Check
                  type='checkbox'
                  checked={optionRandomUse}
                  name="optionRandomUse"
                  id="optionRandomUse"
                  onChange={handleCheckboxChange}
                  bsClass="padding-top-clear " />
              </Col>
            </Form.Group>
          </div>
          : <div>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                  記述文字数の制限をする
              </Col>
              <Col sm={1}>
                <Form.Check
                  type='checkbox'
                  checked={answerFormula === ANSWER_FORMULA.DESCRIPTIVE_SINGLE_ANSWER_LONG_ANSWER ? true : inputLimitType}
                  disabled={answerFormula === ANSWER_FORMULA.DESCRIPTIVE_SINGLE_ANSWER_LONG_ANSWER}
                  name="inputLimitType"
                  id="inputLimitType"
                  onChange={handleCheckboxChange} />
              </Col>
              <Col sm={4}>
                <FormControlValidate
                  type="text"
                  name="inputLimit"
                  value={inputLimit}
                  onChange={this.onChange}
                  disabled={answerFormula === ANSWER_FORMULA.DESCRIPTIVE_SINGLE_ANSWER_LONG_ANSWER ? false : !inputLimitType}
                  validateType={VALIDATE_TYPE.NUMERIC_WITHOUT_ZERO}
                  label="記述文字数の制限"
                  required={inputLimitType || answerFormula === ANSWER_FORMULA.DESCRIPTIVE_SINGLE_ANSWER_LONG_ANSWER || false}
                  ref={(ref) => {
                    if (ref && inputLimitType) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  maxLength="7"
                />
              </Col>
              <Col sm={2} as={Form.Label}>文字まで</Col>
            </Form.Group>
          </div>}
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={4}>
              {isFormulaSelectiveType ? '選択肢' : '正答情報'}
              {!isQuestionUseForm ?
                <span className="required">&nbsp;(※)</span>
            : null}
            </Col>
            <Col sm={7}>
              <Button
                variant="primary"
                className="btn-96"
                onClick={showAddAnswerDlg.bind(this, null)}
                disabled={
                ((answerFormula === ANSWER_FORMULA.DESCRIPTIVE_SINGLE_ANSWER ||
                  answerFormula === ANSWER_FORMULA.DESCRIPTIVE_SINGLE_ANSWER_LONG_ANSWER) &&
                  answerInfo.length >= 1) ||
                ((answerFormula === ANSWER_FORMULA.DESCRIPTIVE_SINGLE_ANSWER_MULTI_CORRECT ||
                  answerFormula === ANSWER_FORMULA.DESCRIPTIVE_MULTIPLE_ANSWER_NO_ORDER ||
                  answerFormula === ANSWER_FORMULA.DESCRIPTIVE_MULTIPLE_ANSWER_ORDER) &&
                  answerInfo.length >= 20)
              }
              >
                追加
              </Button>
            </Col>
            {!isQuestionUseForm &&
              answerInfo && answerInfo.length &&
              (answerFormula === ANSWER_FORMULA.SELECTIVE_SORT_ANSWER ||
              answerFormula === ANSWER_FORMULA.SELECTIVE_SINGLE_ANSWER ||
              answerFormula === ANSWER_FORMULA.SELECTIVE_MULTIPLE_ANSWER) ?
                <Col
                  as={Form.Label}
                  sm={{
                    span: 7,
                    offset: 4
                  }}>
                  <FormControlValidate
                    label={isFormulaSelectiveType ? '選択肢' : '正答情報'}
                    validateType={VALIDATE_TYPE.MIN_ANSWER_LIST}
                    value={answerInfo || []}
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                  />
                </Col>
              : null }
            {!isQuestionUseForm &&
              answerInfo && answerInfo.length &&
              (answerFormula === ANSWER_FORMULA.SELECTIVE_SORT_ANSWER ||
              answerFormula === ANSWER_FORMULA.DESCRIPTIVE_MULTIPLE_ANSWER_ORDER) ?
                <Col
                  as={Form.Label}
                  sm={{
                    span: 7,
                    offset: 4
                  }}>
                  <FormControlValidate
                    label={isFormulaSelectiveType ? '選択肢' : '正答情報'}
                    validateType={VALIDATE_TYPE.QUESTION_ANSWER}
                    value={correctAnswerNumberList || []}
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                  />
                </Col>
              : null}
            {/* Validate question SELECTIVE_SINGLE_ANSWER is only have 1 correct answe */}
            {!isQuestionUseForm &&
            (answerFormula === ANSWER_FORMULA.SELECTIVE_SINGLE_ANSWER) &&
            answerInfo && answerInfo.length > 1 ?
              <Col
                as={Form.Label}
                sm={{
                  span: 7,
                  offset: 4
                }}>
                <FormControlValidate
                  label="選択肢"
                  validateType={VALIDATE_TYPE.QUESTION_SELECTIVE_SINGLE_ANSWER}
                  value={correctAnswerList || []}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                />
              </Col>
            : null}
            {/* Validate answer infor cannot empty */}
            {!isQuestionUseForm ?
              <Col
                as={Form.Label}
                sm={{
                  span: 7,
                  offset: 4
                }}
                hidden={answerInfo.length > 0}>
                <FormControlValidate
                  label={isFormulaSelectiveType ? '選択肢' : '正答情報'}
                  validateType={VALIDATE_TYPE.LABEL}
                  value={answerInfo.length ? answerInfo.length : ''}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  required
                />
              </Col>
            : null}
          </Form.Group>
          {/* Answer list */}
          {answerInfo.length > 0 &&
          <ContentSingleQuestionAnswerList
            answerInfo={answerInfo}
            answerFormula={answerFormula}
            isFormulaType={isFormulaSelectiveType}
            removeAnswer={removeAnswer}
            showAddAnswerDlg={showAddAnswerDlg}
          />}
        </div>
      }
        {/* Advance setting */}
        <Form.Group className="form-info margin-top-20">
          <Col
            sm={10}
            as={Form.Label}
            className="padding-left-clear margin-bottom-10"
          >
            <a role="presentation" className={buttonText} onClick={openOrCloseAdvanceSetting}>
              詳細設定
            </a>
          </Col>
        </Form.Group>
        {isClosedAdvanceSetting === false &&
          <ContentSingleQuestionAdvanceSetting
            ref={(ref) => {
              if (ref) {
                this.refsToValidate.push(ref);
              }
            }}
            buttonText={buttonText}
            questionViewDirection={questionViewDirection}
            absolutePoint={absolutePoint}
            limitTime={limitTime}
            sankakuUseDistinct={sankakuUseDistinct}
            explanationUse={explanationUse}
            explanationHtmlUse={explanationHtmlUse}
            explanationContent={explanationContent}
            explanationZipFileName={explanationZipFileName}
            hintUse={hintUse}
            hintHtmlUse={hintHtmlUse}
            hintContent={hintContent}
            hintZipFileName={hintZipFileName}
            handleExplanationHtmlFileChange={handleExplanationHtmlFileChange}
            handleHintHtmlFileChange={handleHintHtmlFileChange}
            handleChange={this.onChange}
            handleCheckboxChange={handleCheckboxChange}
            openOrCloseAdvanceSetting={openOrCloseAdvanceSetting}
            isClosedAdvanceSetting={isClosedAdvanceSetting}
            questionUseForm={questionUseForm}
          />}
        <Form.Group className="margin-top-20 text-center">
          <Col sm={12}>
            <Button variant="primary" className="btn-96" onClick={questionRegister}>
              OK
            </Button>
          </Col>
        </Form.Group>
      </div>
    );
  }
}
export default ContentSingleQuestion;
